export default "__VITE_ASSET__C7eStO9L__"